export default __webpack_public_path__ + "static/media/nami.123a24e4.jpg";